document.addEventListener("DOMContentLoaded", async () => {
  const collectionContainer = document.querySelector(
    ".ts-collection--products-wrapper"
  );

  const jsonUrl = collectionContainer.dataset.makeModelUrl;

  /**
   * @typedef {Object} MakeModelData
   * @property {string} make - The make of the car.
   * @property {string[]} [models] - The models of the car.
   * @property {string[]} [specialProductPage] - The special product pages for the car.
   */

  /**
   * Fetches and processes make model data.
   * @type {MakeModelData[]}
   */
  const makeModelData = await fetch(jsonUrl)
    .then(async (res) => {
      const data = await res.json();
      return data.createdMakeModel;
    })
    .catch((err) => {
      console.error(err);
      return [];
    });

  const productCards = document.querySelectorAll(".ts-collection--product");
  const ctaButton = document.querySelector(".ts-collection--cta-link");
  productCards.forEach((item) => {
    item.addEventListener("click", handleCardClick);
  });
  function handleCardClick() {
    const { make, model } = this.dataset;
    saveCarInfo({ make, model });
    redirectProductPage(make, model);
  }
  function handleCtaButtonClick() {
    localClean();
    redirectProductPage();
  }

  async function redirectProductPage(make, model) {
    const genericPPUrl = `${window.Shopify.routes.root}products/pedal-commander-${collectionContainer.dataset.linkSuccessor}`;
    if (!make || !model) {
      window.location.href = genericPPUrl;
      return;
    }
    const productUrl = `${window.Shopify.routes.root}products/${make
      .replaceAll(" ", "-")
      .toLowerCase()}-${model.replaceAll(" ", "-").toLowerCase()}`;
    const isSpecialPP = getIsSpecialProductPage(make, model);
    window.location.href = isSpecialPP ? productUrl : genericPPUrl;
  }

  /**
   * Checks if a given make and model combination has a special product page.
   *
   * @param {string} make - The make of the vehicle.
   * @param {string} model - The model of the vehicle.
   * @returns {boolean} - Returns true if the make and model have a special product page, otherwise false.
   */
  function getIsSpecialProductPage(make, model) {
    const foundMake = makeModelData.find((data) => data.make === make);
    if (!foundMake) return false;
    return (
      foundMake?.models.includes(`${make} ${model}`) &&
      foundMake?.specialProductPage?.includes(`${make} ${model}`)
    );
  }

  function saveCarInfo(car) {
    if (car) {
      window.localStorage.setItem(
        "hpValues",
        JSON.stringify({ make: car.make, model: car.model })
      );
    }
  }

  function localClean() {
    localStorage.removeItem("hpValues");
  }
});
